import { Injectable } from '@angular/core';
import { GeneralReportDTO } from '../../interfaces/models';
import { OrderService } from '../order/order.service';

@Injectable({ providedIn: 'root' })
export class ReportsUiService {
  constructor(private readonly orderService: OrderService) {}

  getFormattedReports(response: GeneralReportDTO) {
    const totalRevenue = this.orderService.formatPrice(response.totalRevenue);
    const totalDue = this.orderService.formatPrice(response.totalDue);
    const totalPastDue = this.orderService.formatPrice(response.totalPastDue);
    const totalPaid = this.orderService.formatPrice(response.totalPaid);
    const totalInvoiced = this.orderService.formatPrice(response.totalInvoiced);

    const totalRevenuePersentage = 100;
    const totalDuePersentage = Math.round(totalRevenue ? (totalDue * 100) / totalRevenue : 0);
    const totalPastDuePersentage = Math.round(totalRevenue ? (totalPastDue * 100) / totalRevenue : 0);
    const totalPaidPersentage = Math.round(totalRevenue ? (totalPaid * 100) / totalRevenue : 0);
    const totalInvoicedPersentage = Math.round(totalRevenue ? (totalInvoiced * 100) / totalRevenue : 0);

    return {
      totalRevenue,
      totalDue,
      totalPastDue,
      totalPaid,
      totalInvoiced,
      totalRevenuePersentage,
      totalDuePersentage,
      totalPastDuePersentage,
      totalPaidPersentage,
      totalInvoicedPersentage,
    };
  }
}
